import { render, staticRenderFns } from "./CsiTabs.vue?vue&type=template&id=1de7771c&"
import script from "./CsiTabs.vue?vue&type=script&lang=js&"
export * from "./CsiTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports